import { render, staticRenderFns } from "./BannerVideo.vue?vue&type=template&id=3f9f8abf"
import script from "./BannerVideo.vue?vue&type=script&lang=js"
export * from "./BannerVideo.vue?vue&type=script&lang=js"
import style0 from "./BannerVideo.vue?vue&type=style&index=0&id=3f9f8abf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports